import { Link } from '@tanstack/react-router';

import { DisplayHeading, Eyebrow } from '@/components/editorial';
import type { PublicWritingRecord } from '@/content/schemas';
import type { WritingCategory } from '@/content/registry';

import { WritingCategoryNav, WritingListCard } from './writing-list-card';

type WritingIndexPageProps = {
  posts: PublicWritingRecord[];
  activeCategories: WritingCategory[];
};

export function WritingIndexPage({
  posts,
  activeCategories,
}: WritingIndexPageProps) {
  return (
    <div className="container max-w-5xl px-6 py-16 md:py-24">
      <div className="mb-14">
        <Eyebrow className="mb-4">From the desk</Eyebrow>
        <DisplayHeading as="h1" size="xl" animate={false}>
          Writing
        </DisplayHeading>
        <p className="text-muted-foreground mt-4 max-w-xl text-lg leading-relaxed">
          Engineering deep dives, mental models, notes on Singapore remote, and
          yearly retrospectives.
        </p>
        <p className="text-muted-foreground mt-3 font-mono text-xs">
          {posts.length} {posts.length === 1 ? 'post' : 'posts'}
        </p>
      </div>

      <WritingCategoryNav activeCategories={activeCategories} />

      {posts.length === 0 ? (
        <p className="text-muted-foreground py-16 text-center font-mono text-sm">
          No posts yet. Check back soon.
        </p>
      ) : (
        <div className="flex flex-col gap-6">
          {posts.map((post, index) => (
            <WritingListCard key={post.id} post={post} index={index + 1} />
          ))}
        </div>
      )}

      <div className="mt-12">
        <Link
          to="/"
          className="text-muted-foreground hover:text-brand font-mono text-sm transition-colors"
        >
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
